/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type UserSearchEntity, userSearchSchema } from '@axiom/domain';

export const updateUserSearchDtoSchema = userSearchSchema.pick({ "alertActive": true, "id": true, "name": true }).extend({ "id": userSearchSchema.shape.id.nullish() });
export type UpdateUserSearchDto = Pick<UserSearchEntity, "alertActive" | "name"> & z.infer<typeof updateUserSearchDtoSchema>;
